import { render, staticRenderFns } from "./PublicationCategoryItem.vue?vue&type=template&id=eea14502"
import script from "./PublicationCategoryItem.vue?vue&type=script&lang=js"
export * from "./PublicationCategoryItem.vue?vue&type=script&lang=js"
import style0 from "./PublicationCategoryItem.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports